import Time from 'time-chainer';
import { FilmQuotaManifest } from '@/scripts/services/filmQuotaService/manifest';
import { VideoOverlayPriority, VideoOverlayType } from '@/scripts/store/modules/video/state/VideoOverlay';
import { AuthTrackerIntent } from '@/scripts/models/tracker/AuthTrackerIntent';

export const manifest: FilmQuotaManifest = {
  quota: 3,
  age: Time.days(30),
  presentations: {
    2: {
      name: 'FilmQuotaToConsume3rdOverlay',
      priority: VideoOverlayPriority.Info,
      type: VideoOverlayType.Dismissable,
      presentation: {
        message: {
          en: {
            title: 'This is your last film for the month.',
            message: 'Sign up to watch as many films as you want on\nViddsee. No worries, it’s completely free!',
            action: [{ label: 'Sign up to watch' }],
            dismiss: 'Continue watching',
          },
        },
        descriptor: {
          action: [{
            action: {
              type: 'promptAuth',
              data: {
                authTrackerPayload: {
                  intent: AuthTrackerIntent.FilmQuota,
                },
              },
            },
            tracker: {
              label: 'sign-up',
            },
          }],
        },
      },
    },
    exceeded: {
      name: 'FilmQuotaExceededOverlay',
      priority: VideoOverlayPriority.BlockedError,
      type: VideoOverlayType.Blocking,
      presentation: {
        message: {
          en: {
            title: 'You’ve reached your film limit for the month.',
            message: 'Sign up for free to continue watching and get\nunlimited access to all the films on Viddsee!',
            action: [
              {
                label: 'Sign up to watch',
              },
              {
                head: 'Already have an account? ',
                label: 'Log in',
                tail: '.',
              },
            ],
          },
        },
        descriptor: {
          title: {
            icon: {
              name: 'md:lock',
              align: 'top',
            },
          },
          action: [
            {
              action: {
                type: 'promptAuth',
                data: {
                  authTrackerPayload: {
                    intent: AuthTrackerIntent.FilmQuota,
                  },
                },
              },
              tracker: {
                label: 'sign-up',
              },
            },
            {
              style: 'InTextButton',
              action: {
                type: 'promptAuth',
                data: {
                  authTrackerPayload: {
                    intent: AuthTrackerIntent.FilmQuota,
                  },
                },
              },
              tracker: {
                label: 'log-in',
              },
            },
          ],
        },
      },
    },
  },
};
